import { rd } from '@passionware/monads';
import { Calendar } from 'lucide-react';
import { createDateFilter } from 'v5/api/_common/query/filters/GenericDateFilter';
import type { EnumFilterDisplayValue } from 'v5/patterns/filters/EnumFilterWidget';
import type { FilterDateConfig } from 'v5/patterns/filters/FilterWidget.types';
import { DEFAULT_REPORT_RELATIVE_DATE } from './reportDateFilter';

/**
 * A report's date chip: the backend's relative values as presets, or a range of days. "After" and
 * "before" have no stored shape.
 */
export function createReportDateFilterConfig(
  label: string,
  presets: EnumFilterDisplayValue<string>[]
): FilterDateConfig<string> {
  const options = rd.of(presets);
  // the server resolves the relative values when it exports; nothing is matched here
  const resolver = rd.of(createDateFilter<string>({}));
  return {
    label,
    icon: <Calendar />,
    type: 'date',
    createDefaultValue: () => ({
      operator: 'preset',
      value: DEFAULT_REPORT_RELATIVE_DATE
    }),
    options: {
      useOptions: () => options,
      useResolver: () => resolver,
      operators: ['between', 'equal']
    }
  };
}

/** The "booked" chip: a range of days, its booking statuses kept from the stored condition. */
export function createReportBookedFilterConfig(
  label: string
): FilterDateConfig<string> {
  const config = createReportDateFilterConfig(label, []);
  return { ...config, options: { ...config.options, operators: ['between'] } };
}
